import { AppDefinition } from '../../types/apps';

export const LegalCodeViewerAppDefinition: AppDefinition = {
  appId: 'legal-code-viewer',
  name: 'Legal Code Viewer',
  description: 'View and navigate legal codes and statutes with full section content',
  version: '1.0.0',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Scales',
    phosphorWeight: 'duotone',
    color: '#64748b',
  },
  events: {},
  entityTypes: ['VerifiedSource', 'LegalCode'],
  component: 'LegalCodeViewerApp',
  requiresProps: false,
  requiresEntity: true,
  supportedFileTypes: [],
};

